import React from "react";
import "./AppraisalProgress.css";
import AppraisalList from "./AppraisalList";
import Header from "./AppraisalList/component/Header/Header";

const AppraisalProgress = () => {
  return (
    <>
      <Header />
      <AppraisalList baseFilters={{ frequency: "Monthly" }} />
    </>
  );
};

export default AppraisalProgress;
